module.exports = __webpack_public_path__ + "static/img/file-yellow.f3a35380.svg";